import { useMutation } from '@tanstack/react-query';
import { useParticipantsPersonEventsApi } from 'services';

export const useVerifyMail = () => {
  const { verifyMail } = useParticipantsPersonEventsApi();

  return useMutation({ mutationFn: verifyMail });
};
